import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RedAlertComponent } from './alert.component';

@NgModule({
    declarations: [
      RedAlertComponent
    ],
    imports     : [
        CommonModule,
        MatButtonModule,
        MatIconModule
    ],
    exports     : [
        RedAlertComponent
    ]
})
export class RedAlertModule
{
}
